import { Component, Input } from '@angular/core';

@Component({
  selector: 'allas-contact-header',
  template: `
    <div class="mb-8 fs-condensed">
      <h1 class="text-3xl sm:text-4xl font-normal text-gray-900 mb-4">
        {{ title }}
      </h1>
      <p class="text-lg text-gray-600 max-w-[56rem]">
        {{ subtitle }}
      </p>
    </div>
  `,
  standalone: true,
})
export class ContactHeaderComponent {
  @Input() title: string = '';
  @Input() subtitle: string = '';
}
